export default __webpack_public_path__ + "static/lihook-desktop-7f611ffdab1a48b7ceaab99bc401a619.png";